import { useState, useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { UserAuth } from "../contexts/AuthContext";
import { AuthorizationService } from "../services/authorizationService";
import { Flex, Spinner } from "@chakra-ui/react";

const ProtectedBusinessRoute = ({ children, fallbackPath = "/home" }) => {
  const { businessId } = useParams();
  const { user } = UserAuth();
  const [hasAccess, setHasAccess] = useState(null);

  useEffect(() => {
    const checkAccess = async () => {
      if (!user || !businessId) {
        setHasAccess(false);
        return;
      }

      try {
        const businessDoc = await getDoc(doc(db, "businesses", businessId));
        if (!businessDoc.exists()) {
          setHasAccess(false);
          return;
        }
        const business = businessDoc.data();

        if (business.ownerUid && business.ownerUid === user.uid) {
          setHasAccess(true);
          return;
        }
        if (user.isPlatformAdmin) {
          setHasAccess(true);
          return;
        }
        if (business.campaignId) {
          const ok = await AuthorizationService.canAccessCampaign(
            user.uid,
            business.campaignId
          );
          setHasAccess(ok);
          return;
        }
        setHasAccess(false);
      } catch (err) {
        console.error("Error checking business access:", err);
        setHasAccess(false);
      }
    };

    checkAccess();
  }, [user, businessId]);

  if (hasAccess === null) {
    return (
      <Flex minH="100vh" justify="center" align="center">
        <Spinner size="xl" />
      </Flex>
    );
  }

  return hasAccess ? children : <Navigate to={fallbackPath} />;
};

export default ProtectedBusinessRoute;
